export default __webpack_public_path__ + "static/media/DSCN2317.c75c595c.JPG";